<template>
  <div class='ml-page-table'
       v-loading="loading"
       element-loading-text="加载中……"
       element-loading-spinner="el-icon-loading">
    <el-table
        ref='elTable'
        :height="height"
        :data='dataList'
        v-bind='$attrs'
        v-on='$listeners'>
      <slot name='first-column'></slot>
      <slot name='second-column'></slot>
      <el-table-column
          v-if='showIndex'
          width='50'
          label='序号' header-align='center' align='center'>
        <template slot-scope='scope'>
          <span>{{ offset + scope.$index + 1 }}</span>
        </template>
      </el-table-column>

      <template v-for='(v,k) in columns'>
        <template v-if='v&&!v.hide&&!v.slot'>
          <el-table-column
              :column-key='v.value'
              :key='k'
              :prop="v.field?v.field:typeof(v.value)=='string'?v.value:''"
              :label='v.title'
              :width='v.width||120'
              :show-overflow-tooltip='v.overflow||true'
              :header-align="v.header_align?v.header_align:'center'"
              :align="v.align?v.align:'center'"
              :fixed='v.fixed'
              :sortable='v.sortable?v.sortable:false'>
            <template slot-scope='{row,column}'>
              <div v-if="typeof(v.value)=='string'">
                <span v-if="v.value">{{ row[v.value] }}</span>
                <span v-else v-html='row[column.property]'></span>
              </div>
            </template>
          </el-table-column>
        </template>
        <template v-else-if='!v.hide&&v.slot'>
          <slot :name='v.field'/>
        </template>
      </template>

      <slot></slot>
      <slot name='handle-column'></slot>
    </el-table>

    <div class='ml-page-table__footer'
         style='margin-top: 10px;display: flex;align-items: center;justify-content: space-between'>
      <div style="display: flex;align-items: center;justify-content: flex-start;gap: 5px">
        <el-button title='点击进行设置列' icon='el-icon-setting' size='mini' @click='customColumnShow=true'/>
        <slot name='footer'/>
      </div>
      <div style="display: flex;align-items: center;">
        <slot name='pageBefore'/>
        <Pagination :total="total" :limit.sync="pageSize"
                    :hidden='total===0' :page.sync="currentPage" @pagination="getList"></Pagination>
      </div>
    </div>
    <!--    列设置-弹窗  -->
    <MColumnSetting :visible.sync='customColumnShow' @userChange='columnSettingChange'
                    :column.sync='allColumns' :table-name='tableName' @back='columnSettingBack'
                    @save='columnSettingSave'
                    :editable-cols='editableCols'/>
  </div>
</template>

<script>
import MColumnSetting from '@/components/MSettingColumn/MColumnSetting'

export default {
  name: 'MlPageTable',
  components: {MColumnSetting},
  props: {
    showSlot: {
      type: Boolean,
      default: false
    },
    //全部列
    allColumns: {
      type: Array,
      default: () => [
        {
          "title": "客户名称",
          "value": "customer_name",
          "width": 120,
          "header_align": "center",
          "align": "center",
          "sortable": "custom",
          "field": "customer_id",
        }
      ]
    },
    showIndex: {
      default: false
    },
    // loading: {
    //   type: Boolean,
    //   default: false
    // },
    offset: {
      default: 0
    },
    total: {
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    tableName: {
      type: String,
      required: true
    },
    editableCols: {
      type: Array,
      default: () => []
    },
    heightValue: {
      type: [String, Number],
      default: '0'
    },
    maxHeight: {
      type: [String, Number],
      default: ''
    },
    dataList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  watch: {
    heightValue: function (val) {
      this.height = val
      this.$forceUpdate()
    },

  },
  data() {
    return {
      loading: false,
      // dataList: [],
      columns: [],//表格显示列
      pagingData: {current_page: 1, page_size: 10},
      customColumnShow: false,
      isColSet: false,
      height: null
    }
  },
  methods: {
    editCellVal(row, field) {
      this.$emit('editCellVal', row, field)
    },
    clearSelection() {
      this.$refs.elTable.clearSelection()
    },
    /**
     * 获取table选中行
     * 父组件用
     */
    interfaceGetSelection: function () {
      return this.$refs.elTable.selection
    },
    // eslint-disable-next-line no-unused-vars
    tableRowClassName({row, rowIndex}) {
      return 'default-table-row'
    },
    getDefaultColumns() {
      // console.log(JSON.stringify(this.allColumns))
      if (localStorage.getItem(`table-column:${this.tableName}`)) {
        const tableSet = JSON.parse(localStorage.getItem(`table-column:${this.tableName}`))
        let userColumn = tableSet.user_columns
        this.columns = [...userColumn]
        this.isColSet = true
      } else {
        this.isColSet = false
        // console.log(JSON.stringify(this.allColumns))
        this.columns = [...this.allColumns]
      }
    },
    columnSettingChange(userColumn) {
      //设置列-修改表显示
      this.columns = [...userColumn]
      this.isColSet = true
    },
    // eslint-disable-next-line no-unused-vars
    columnSettingSave(userColumn) {
      const cols = []
      for (const colIndex in userColumn) {
        // eslint-disable-next-line no-console
        // console.log(colIndex, userColumn[colIndex])
        if (userColumn[colIndex]) {
          const col = userColumn[colIndex]
          cols.push({
            hide: col.hide || false,
            title: col.title || `col_${colIndex}`,
            value: col.value,
            field: col.field || col.value,
            width: col.width || 100,
            header_align: col.header_align || 'center',
            align: col.align || 'center',
            slot: col.slot || false,
            fixed: false,
            sortable: false,
            editable: false,
          })
        } else {
          // eslint-disable-next-line no-console
          console.log(userColumn)
        }
      }
      // eslint-disable-next-line no-console
      // console.log(JSON.stringify(cols))
      this.customColumnShow = false
      this.isColSet = true

    },
    // eslint-disable-next-line no-unused-vars
    columnSettingBack(userColumn) {
      this.isColSet = false

      this.getDefaultColumns()
    },
    async getList() {
      this.loading = true
      await this.$emit('getList')
      setTimeout(() => {
        this.loading = false
      }, 100)
    },
    rowClickEvent(row, column, event) {
      this.$emit('row-click', row, column, event)
    }
  },

}
</script>

